import { render, staticRenderFns } from "./chat-box.vue?vue&type=template&id=46863dd5&scoped=true&"
import script from "./chat-box.vue?vue&type=script&lang=js&"
export * from "./chat-box.vue?vue&type=script&lang=js&"
import style0 from "./chat-box.vue?vue&type=style&index=0&id=46863dd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46863dd5",
  null
  
)

export default component.exports